export default __webpack_public_path__ + "static/media/mt_portfolio-08.24ad7f62.png";